export default __webpack_public_path__ + "static/media/amilcareBack.67c0377b.png";